/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';

import { IProductDescriptionData } from './product-description.data';
import { IProductDescriptionProps } from './product-description.props.autogenerated';

/**
 *
 * ProductDescription component
 * @extends {React.PureComponent<IProductDescriptionProps<IProductDescriptionData>>}
 */
class ProductDescription extends React.PureComponent<
  IProductDescriptionProps<IProductDescriptionData>
  > {
  private _productAttributeTastingNotes: string = 'TASTING NOTES';
  private _productAttributeCookbookDescriptions: string = 'COOKBOOKDESCRIPTION';
  public render(): JSX.Element | null {
    const content: IProductDescriptionData = this.props.data;
    if (
      !(
        content &&
        content.productSpecificationData &&
        content.productSpecificationData.result
      )
    ) {
      return null;
    }
    const productAttributes = content.productSpecificationData.result;
    const productAttribute = productAttributes.filter(
      attribute =>
        attribute.Name!.toUpperCase() === this._productAttributeTastingNotes
    );
    if (
      productAttribute &&
      productAttribute.length &&
      productAttribute[0].TextValue
    ) {
      return (
        <div className='product-attribute-nv'>
          <RichTextComponent
            className='product-attribute-nv-value'
            text={productAttribute[0].TextValue}
          />
        </div>
      );
    } else {
      const cookbookAttribute = productAttributes.filter(
        attribute =>
          attribute.Name!.toUpperCase() === this._productAttributeCookbookDescriptions);
      if (
        cookbookAttribute &&
        cookbookAttribute.length &&
        cookbookAttribute[0].TextValue
      ) {
        return (
          <div className='product-attribute-nv'>
            <RichTextComponent
              className='product-attribute-nv-value'
              text={cookbookAttribute[0].TextValue}
            />
          </div>
        );
      }
    }
    return null;
  }
}

export default ProductDescription;
